// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"4380f533","150":"26b71225","194":"f3c66f57","216":"5d46bf8c","274":"dfc117c2","434":"33c43216","555":"7d848854","616":"c19c769e","677":"9b386511","773":"6a3c68c3","925":"31bd92c2","986":"96c3dda0"}[chunkId] + ".chunk.js";
};